<template>
  <!-- partial -->
  <div class="page-content">
    <div class="row">
      <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12">
        <h5 class="txt-dark">
          <back-button
            link="/planned-maintenance/parameter-setups"
          ></back-button>
          Add Parameter Setup
        </h5>
      </div>
      <!-- Breadcrumb -->
      <div class="col-lg-4 col-sm-6 col-md-4 col-xs-12">
        <ol class="breadcrumb breadcrumb-line" style="float: right">
          <li class="breadcrumb-item">
            <router-link :to="`/`">Dashboard</router-link>
          </li>
          <li class="breadcrumb-item">Planned Management</li>
          <li class="breadcrumb-item">
            <router-link :to="`/planned-maintenance/parameter-setups`"
              >Parameter Setup</router-link
            >
          </li>
          <li class="breadcrumb-item active" aria-current="page">Add</li>
        </ol>
      </div>
    </div>
    <!-- /Breadcrumb -->
    <!-- Form  -->
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <!-- Tab -->
            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <li class="nav-item">
                <a
                  class="nav-link active"
                  id="requisition-tab"
                  data-bs-toggle="tab"
                  href="#requisition"
                  role="tab"
                  aria-controls="requisition"
                  aria-selected="true"
                  >Parameter Setup</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="peremeterSetDetial-tab"
                  data-bs-toggle="tab"
                  href="#peremeterSetDetial"
                  role="tab"
                  aria-controls="peremeterSetDetial"
                  aria-selected="false"
                  >Parameter Setup Details</a
                >
              </li>
            </ul>
            <div class="tab-content border border-top-0 p-3" id="myTabContent">
              <!-- For Parameter Setup Sectiion -->
              <div
                class="tab-pane fade show active"
                id="requisition"
                role="tabpanel"
                aria-labelledby="requisition-tab"
              >
                <h4>Parameter Setup</h4>
                <hr />
                <parameter-setup :form="form"></parameter-setup>
              </div>
              <!-- For Requsition Details -->
              <div
                class="tab-pane fade"
                id="peremeterSetDetial"
                role="tabpanel"
                aria-labelledby="peremeterSetDetial-tab"
              >
                <h4>Parameter Setup Details</h4>
                <hr />
                <parameter-setup-detail-form
                  :form="form"
                ></parameter-setup-detail-form>
              </div>
            </div>
            <br />
            <div class="form-group mb-0">
              <submit-button
                :isLoading="isLoading"
                @submit="save"
                text="Save"
                style="float: right"
              ></submit-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- partial -->
</template>
<script type="text/javascript">
import axios from "axios";
import ParameterSetup from "./parameter-setup-form.vue";
import ParameterSetupDetailForm from "./parameter-setup-detail-form.vue";
export default {
  components: { ParameterSetup, ParameterSetupDetailForm },
  name: "Parameter SetupCreate",
  data() {
    return {
      form: {
        vessel_id: "",
        marchinery_group: "",
        parameter_type: "",

        parameter_setup_details: [
          {
            unit_id: "",
          },
        ],
      },
      vessels: [],
      spareParts: [
        { id: 1, name: "Spare 1" },
        { id: 2, name: "Spare 2" },
      ],
      isLoading: false,
    };
  },
  methods: {
    async save() {
      try {
        this.isLoading = true;
        this.form.parameter_setup_details.company_id = this.company.id;
        this.crew = await axios.post("/parameter_setups", this.form);
        // await this.handleFileUpload();
        this.isLoading = false;
        this.$router.push("/planned-maintenance/parameter-setups");
      } catch (e) {
        this.isLoading = false;
      }
    },

    async handleFileUpload() {
      this.doc_attachment = this.$refs.doc_attachment
        ? this.$refs.doc_attachment.files[0]
        : "";
      let formData = new FormData();
      formData.append("id", this.crew.id);
      formData.append("doc_attachment", this.doc_attachment);
      await this.$axios
        .post("upload_attachments", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((data) => {
          // this.filePath = data.data
          console.log(data);
        })
        .catch(function () {
          console.log("FAILURE!!");
        });
    },
  },
};
</script>
